import React from 'react';

import { Box, Text } from '@betterment/samba-react';

import { EnvelopeRow } from './EnvelopeRow';
import { HouseholdAccountsQuery } from './graphql/query.householdAccounts.generated';
import { HouseholdEnvelopeYtdReturnsQuery } from './graphql/query.householdEnvelopeYtdReturns.generated';
import { HeaderCell } from './HeaderCell';

type Envelope = HouseholdAccountsQuery['household']['accounts'][number]['envelope'];
type AccountHolder = HouseholdAccountsQuery['household']['accounts'][number]['accountHolders'][number];

export const EnvelopesTable: React.FC<{
  envelopes: Envelope[];
  accountHoldersMap: Map<string, AccountHolder[]>;
  ytdReturnsData?: HouseholdEnvelopeYtdReturnsQuery['household']['envelopeYtdReturns'];
  ytdReturnsLoading: boolean;
  showYtdReturns: boolean;
}> = ({ envelopes, accountHoldersMap, ytdReturnsData, ytdReturnsLoading, showYtdReturns }) => {
  const gridColumns = showYtdReturns
    ? 'minmax(auto, 140px) 1fr 1fr minmax(auto, 150px) minmax(auto, 200px) 32px'
    : 'minmax(auto, 140px) 1fr 1fr minmax(auto, 200px) 32px';

  const ytdReturnsMap = new Map(ytdReturnsData?.map(ytd => [ytd.envelopeId, ytd.ytdReturn]) ?? []);

  return (
    <Box
      css={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: gridColumns,
        gridAutoRows: 'auto',
      }}
    >
      <HeaderCell css={{ gridColumn: '1' }}>
        <Text color="text.weak">Clients</Text>
      </HeaderCell>
      <HeaderCell css={{ gridColumn: '2' }}>
        <Text color="text.weak">Goal</Text>
      </HeaderCell>
      <HeaderCell css={{ gridColumn: '3' }}>
        <Text color="text.weak">Target</Text>
      </HeaderCell>
      {showYtdReturns && (
        <HeaderCell css={{ gridColumn: '4', justifyContent: 'end', pr: 'space.300' }}>
          <Text color="text.weak">Earned YTD</Text>
        </HeaderCell>
      )}
      <HeaderCell css={{ gridColumn: showYtdReturns ? '5' : '4', justifyContent: 'end', pr: 'space.300' }}>
        <Text color="text.weak">Balance</Text>
      </HeaderCell>
      {envelopes.map(envelope => {
        const ytdReturn = ytdReturnsMap.get(envelope.id);
        return (
          <EnvelopeRow
            key={envelope.id}
            envelope={envelope}
            accountHolders={accountHoldersMap.get(envelope.id) || []}
            ytdReturn={ytdReturn}
            ytdReturnsLoading={ytdReturnsLoading}
            showYtdReturns={showYtdReturns}
          />
        );
      })}
    </Box>
  );
};
